var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 259,
    viewBox: "0 0 239 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.651 229.134L35.9863 179.965L95.3674 50.1593L170.158 28.9299L203.032 99.3278L143.651 229.134Z",
    stroke: "#D1FB00",
    strokeWidth: 4.69118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2852 155.613L158.52 126.3",
    stroke: "#D1FB00",
    strokeWidth: 2.34559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.957 105.114C121.415 111.644 118.098 118.897 111.547 121.312C104.996 123.728 97.6919 120.392 95.2332 113.862C92.7744 107.332 96.0918 100.08 102.643 97.6644C109.194 95.2489 116.498 98.5842 118.957 105.114Z",
    stroke: "#D1FB00",
    strokeWidth: 2.34559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.574 168.052C140.115 161.522 132.811 158.186 126.26 160.602C119.709 163.017 116.392 170.269 118.85 176.799C121.309 183.329 128.613 186.665 135.164 184.25C141.715 181.834 145.033 174.582 142.574 168.052Z",
    stroke: "#D1FB00",
    strokeWidth: 2.34559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.039 58.9004L164.265 67.6804",
    stroke: "#D1FB00",
    strokeWidth: 4.69118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.457 2.45874L154.75 63.2916",
    stroke: "#AED100",
    strokeWidth: 4.69118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ec0f164d183b16f3522e218827ae1aa1.svg";
export { ForwardRef as ReactComponent };